import React from 'react';
import PropTypes from 'prop-types'
import { Grid, IconButton, Divider } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import { useQuery, useMutation } from '@apollo/client';
import TextField from '../../../atoms/TextField';
import { useTranslation } from '../../../../config/i18n';
import { MessageBubble, MessageForm } from './style';
import {
  GET_APPLICATION_MESSAGES,
} from '../../../../apollo/queries';
import { CREATE_MESSAGE } from '../../../../apollo/mutations';
import EmptyCard from '../../EmpyCard';
import MutationsStatus from '../../MutationsStatus';

// eslint-disable-next-line react/prop-types
const MessagesList = ({ application, loggedUser }) => {
  const { t } = useTranslation(['dashboard', 'common', 'warnings']);
  const [message, setMessage] = React.useState('');

  const { data: messagesData } = useQuery(GET_APPLICATION_MESSAGES, {
    variables: {
      application: application.id,
      first: 20,
    },
  });

  const { data: messages = [] } = (messagesData && messagesData.applicationMessages) || {};

  const handleCompletedSendMessage = () => {
    setMessage('');
  };

  const [
    saveMessage,
    { loading: mutationLoading, error: mutationError, data: mutationData },
  ] = useMutation(CREATE_MESSAGE, {
    onCompleted: handleCompletedSendMessage,
  });

  const sendMessageHandler = () => {
    saveMessage({
      variables: {
        input: { message, application: application.id },
      },
      refetchQueries: () => [
        {
          query: GET_APPLICATION_MESSAGES,
          variables: {
            application: application.id,
            first: 20,
          },
        },
      ],
    });
  };

  const messageContentChangeHandler = e => {
    setMessage(e.target.value);
  };

  const orederedMessages = [...messages].reverse();

  return (
    <>
      <MutationsStatus loading={mutationLoading} error={mutationError} success={mutationData} />
      <Grid container spacing={3}>
        <Grid container spacing={1}>
          {orederedMessages && orederedMessages.length > 0 ? (
            orederedMessages.map(messageItem => (
              <Grid
                container
                item
                justify={
                  loggedUser && loggedUser.id === messageItem.user_id ? 'flex-end' : 'flex-start'
                }
              >
                <MessageBubble
                  variant="body2"
                  isSender={loggedUser && loggedUser.id === messageItem.user_id}
                >
                  {messageItem.message}
                </MessageBubble>
              </Grid>
            ))
          ) : (
            <EmptyCard message={t('warnings:no_messages')} />
          )}
        </Grid>

        <Divider />

        <MessageForm container direction="row" justify="space-between">
          <Grid item lg={10}>
            <TextField
              value={message}
              onChange={messageContentChangeHandler}
              multiline
              variant="outlined"
              label={`${t('write_message')}...`}
              rowsMax="4"
            />
          </Grid>
          <Grid item container lg={2} direction="row" justify="flex-end" alignItems="center">
            <IconButton onClick={sendMessageHandler}>
              <SendIcon color="primary" />
            </IconButton>
          </Grid>
        </MessageForm>
      </Grid>
    </>
  );
};

MessagesList.propTypes = {
  application: PropTypes.object.isRequired,
  loggedUser: PropTypes.object.isRequired,
};

export default MessagesList;
